import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import Widget from "../../Utility/Crud/Widget";

export default class ChipWidget extends Chip {
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const color = this.props.widget ? Widget.getColor() : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {Widget.getIcon({ fontSize: "small", sx: { color: iconColor } })}
      </MUIAvatar>
    );
  }

  /**
   * @returns {string} The widget description.
   */
  getLabel() {
    return this.props.widget
      ? Widget.getDisplayName(this.props.widget)
      : this.props.nullLabel || "Unknown Widget";
  }
}
